import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import {
  ExperimentUUIDToFlagName,
  useSendExperimentData as useSendExperimentDataShared,
} from '@lyrahealth-inc/shared-app-logic'
import { ExperimentDataParams } from '@lyrahealth-inc/shared-app-logic/src/features/experiments/hooks/useSendExperimentData'
import { useLDClient } from '@lyrahealth-inc/shared-app-logic/src/features/flags/launchdarkly-client-sdk.web'
import { useGetSnsExperimentEventPlatformType } from '@lyrahealth-inc/ui-core-crossplatform'

import { postExperimentEntrypoint } from '../../data/appGlobals/appGlobalsActions'
import { getDeviceUUID } from '../../data/appGlobals/appGlobalsSelectors'
import { getSessionId } from '../../data/session/sessionSelectors'
import { getId } from '../../data/user/userSelectors'

export const useSendExperimentData = () => {
  const lyraId = useSelector(getId)
  const deviceUUID = useSelector(getDeviceUUID)
  const platform = useGetSnsExperimentEventPlatformType()

  const sessionId = useSelector(getSessionId)

  const ldClient = useLDClient()

  const sendExperimentData = useSendExperimentDataShared({
    deviceUUID,
    lyraId,
    postExperimentEntrypoint: useCallback((experimentPayload) => {
      postExperimentEntrypoint(experimentPayload)
    }, []),
    platform,
    sessionId,
  })

  return useCallback(
    ({ experimentUUID, joinKeys }: ExperimentDataParams) => {
      const flagName = ExperimentUUIDToFlagName[experimentUUID]

      if (!flagName) {
        console.debug('DEBUG[useSendExperimentData]: No flag name found for experiment UUID: ', experimentUUID)
        return
      }

      const userInExperiment = !!ldClient?.variationDetail(flagName, {})?.reason?.inExperiment
      const flagValue = ldClient?.variation(flagName)
      if (userInExperiment) {
        const payloadParams = {
          experimentUUID,
          joinKeys,
          flagName,
          flagValue: String(flagValue),
        }
        console.debug(
          'DEBUG[useSendExperimentData]: User is in experiment sending experiment sns data \npayloadParams: ',
          payloadParams,
        )
        sendExperimentData(payloadParams)
      } else {
        console.debug('DEBUG[useSendExperimentData]: User is NOT in experiment sns data will not be sent')
      }
    },
    [ldClient, sendExperimentData],
  )
}
